const Hero = () => {
    return (
        <div className="olm-gradient flex py-4 px-4 sm:px-6 pb-0 lg:px-8">
            <div className="container m-auto relative">
                {/* Decorative Images */}
                <div className="hidden absolute md:block top-10 left-0 w-36 h-36">
                    <img
                        src="/assets/landing/partner-with-us/hero-left.svg"
                        alt="Decoration Left"
                        width="500"
                    />
                </div>
                <div className="absolute md:hidden top-10 left-0">
                    <img
                        src="/assets/landing/partner-with-us/mobile-hero-left.svg"
                        alt="Decoration Bottom Left"
                        width="500"
                    />
                </div>

                <div className="absolute md:hidden bottom-4 right-10">
                    <img
                        src="/assets/landing/partner-with-us/mobile-hero-right.svg"
                        alt="Decoration Right"
                        width="500"
                    />
                </div>

                <div className="hidden md:block absolute bottom-10 right-0 w-36 h-36">
                    <img
                        src="/assets/landing/partner-with-us/hero-right.svg"
                        alt="Decoration Bottom Right"
                    />
                </div>

                {/* Main Content */}
                <div className="relative z-20 flex flex-col items-center max-w-4xl mx-auto text-center md:py-20 py-28">
                    <h1 className="text-5xl font-bold text-white mb-4">
                        Our Partners <br className="md:hidden" /> in Real{' '}
                        <br className="md:hidden" /> Estate Success
                    </h1>
                    <p className="text-lg text-white">
                        Unlock the full potential of your real estate marketing
                        with industry-leading partners.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Hero
